document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('#header-component');
  if (!header) return;

  header.dataset.menuStyle = 'drawer';

  new MutationObserver(() => {
    if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
});